// modifer: styles/jss/nextjs-material-kit-pro/pages/componentsSections/pillsStyle.js
import { section, container } from 'styles/jss/original/base';

const styles = {
  section: {
    ...section,
    padding: '60px 0 0',
    '@media (max-width: 992px)': {
      padding: '40px 0 0'
    },
    '@media (max-width: 640px)': {
      padding: '30px 0 0'
    }
  },
  container
};

export default styles;
